import styled from 'styled-components';
import { FONT_FAMILY } from '../../../common/styles/fontStyles';
import COLORS from '../../../common/styles/color-pallete';

export const QrWrapper = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const QrBox = styled.div`
  background-color: ${COLORS.white};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 350px;
  min-height: 381.9px;
  border: 10px;
  padding: 16px 20px 32px 20px;
  gap: 24px;
  overflow-wrap: anywhere;

  .qrHeader {
    align-items: center;
    gap: 16px;
    display: flex;
    flex-direction: column;
  }
  .crossButtonContainer {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  .crossButton {
    background: none;
    cursor: pointer;
    border: none;
    outline: none;
  }

  .qrText {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .qrheadingText {
    text-align: center;
    font-size: 18px;
    line-height: 24px;
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .qrDescreptionText {
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
  }
`;
